<template>
    <div>
        <h3 class="mt-4" v-if="title">Documentos subidos:</h3>
        <ul class="list-unstyled">
            <template v-for="documento in data.documentos">
                <li :key="documento.id" v-if="!esImagen(documento.ruta_fichero)">
                    <a :href="documento.url" target="_blank" class="btn-link text-secondary"><i class="far fa-fw fa-image"></i> {{ documento.nombre }}</a>
                    <button style="border: 0; background-color: white; margin-right: 1px; padding-right: 1px;" @click="showModal('borrar-' + documento.id)">&#10006;</button>
                    <button style="border: 0; background-color: white; transform: scaleX(-1);" class="m-0 p-0" @click="showModal('editar-' + documento.id)">&#9998;</button>
                    <BorrarModalComponent
                        :name="'borrar-' + documento.id"
                        :title="'Borrar documento de ' + data.nombre + ' ' + data.apellidos"
                        confirmButton="¿Está segur@ de borrar este documento?"
                        v-on:close="() => closeModal()"
                        v-on:confirm="() => borrarDocumento(documento.id)"
                    >
                    </BorrarModalComponent>
                    <EditDocumento :documento="documento" @close="closeModal()" @confirm="editarDocumento"></EditDocumento>
                </li>
            </template>
        </ul>
        <div class="col-12 col-md-6 col-lg-12">
            <label>Subir documentación</label>
            <vue-dropzone
                ref="myVueDropzone"
                id="dropzone"
                :options="dropzoneOptions"
                v-on:vdropzone-success="imagenSubida"
                :useCustomSlot=true
            >
                <div class="dropzone-custom-content">
                    <h3 class="dropzone-custom-title">Arrastra los archivos aquí para subirlos</h3>
                </div>
            </vue-dropzone>
        </div>
        <b-card class="mt-3" v-if="data.documentos && data.documentos.length > 0">
            <b-card-title>Documentación subida</b-card-title><br><br>
            <b-card-body class="p-0">
                <b-col cols="12" class="p-0">
                    <b-col class="p-0 text-center">
                        <template v-for="documento in data.documentos">
                            <img class="mr-2" v-if="esImagen(documento.ruta_fichero)" :key="documento.id" :src="documento.url" width="200" />
                        </template>
                    </b-col>
                </b-col>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";
import EditDocumento from "./modals/EditDocumento";

export default {
    props: ['data', 'params', 'ruta', 'url' , 'title'],
    data() {
        return {
            dropzoneOptions: {
                url: this.url,
                thumbnailWidth: 150,
                maxFilesize: 20,
                headers: {
                    'Accept': 'application/json'
                },
                uploadMultiple: false,
                maxFiles: 5
            }
        }
    },
    methods: {
        borrarDocumento(id) {
            this.params.documento_id = id;

            const params = this.params;

            this.$store.dispatch(this.config.getVuexAlias(this.ruta), params).then(res => {
                this.$toast.success(res.data.message);
                this.$emit('actualizado');
            }).catch(error => {
                this.$toast.error('El archivo que intentas borrar no existe');
            });
        },
        editarDocumento(documento) {
            this.$emit('editarDocumento', documento);
        },
        imagenSubida(file, response) {
            this.$emit('actualizado');
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
        },
        esImagen(documento) {
            const formatoImagen = /\.(png|jpg|jpeg)$/i;
            return formatoImagen.test(documento);
        }
    },
    components: { vueDropzone: vue2Dropzone, BorrarModalComponent, EditDocumento }
}
</script>